import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';

const ACCESS_REQUEST_SOUND_FILE = 'access-request-doorbell.m4a';

export const getAccessRequestSoundUrl = (): string =>
    isElectron ? `./${ACCESS_REQUEST_SOUND_FILE}` : `/${ACCESS_REQUEST_SOUND_FILE}`;
